import PopoverComponent from "./PopoverComponent";

export default PopoverComponent;